var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSliders = function SvgSliders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#363840",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14 13.334H9.333M8.19 13.334H2M14 8H8M5.333 8H2M14 2.667h-3.333M8 2.667H2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.524,
    cy: 2.666,
    r: 1.405,
    fill: "#F5F5F5",
    stroke: "#363840"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.476,
    cy: 8,
    r: 1.405,
    fill: "#F5F5F5",
    stroke: "#363840"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.524,
    cy: 13.334,
    r: 1.405,
    fill: "#F5F5F5",
    stroke: "#363840"
  })));
};
export default SvgSliders;